import UploadLogApi from '@/api/upload-log'
import { uploadLogFiles } from '@ahaslides-product/frontend-toolkit'
import * as Sentry from '@sentry/vue'

const uploadLogs = async (_, { audienceId, presentationId }) => {
  try {
    await uploadLogFiles((formData) => UploadLogApi.sendLog(formData, { audienceId, presentationId }))
  } catch (error) {
    Sentry.captureException(error)
  }
}

export default {
  uploadLogs,
}
